import { Card, Typography, Box, CardContent } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

function Contact() {
    return (
        <Box
            sx={{
                display: 'flex',
                marginBottom: '20px',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 3,
                flexDirection: { xs: 'column', md: 'row' }
            }}
        >
            <Card sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, width: { xs: '90%', md: '80%' }, mb: { xs: 3, md: 0 } }}>
                <CardContent>
                    <Typography sx={{ fontFamily: 'Gowun Batang', fontWeight: '700', fontSize: { xs: 'h5.fontSize', md: 'h4.fontSize' } }} variant='h4' mb={1}>연락처 정보</Typography>
                    <Typography variant='body1' sx={{ fontSize: { xs: 'subtitle1.fontSize', md: 'body1.fontSize' } }}><LocationOnIcon /> 123 Seoul Street, Gangnam-gu, Seoul</Typography>
                    <Typography variant='body1' sx={{ fontSize: { xs: 'subtitle1.fontSize', md: 'body1.fontSize' } }} >📞 +82 10-1234-5678</Typography>
                </CardContent>
                <Box sx={{ width: '100%', height: { xs: 300, md: 400 } }}>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.398817001658!2d126.95643393890586!3d37.56922550188702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca284471b762f%3A0x70769fb7c4484349!2sDongnimmun-ro%2C%20Seodaemun-gu%2C%20Seoul%2C%20Cor%C3%A9e%20du%20Sud!5e0!3m2!1sfr!2sfr!4v1685955328185!5m2!1sfr!2sfr"
                        style={{ border: 0, width: '100%', height: '100%' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Google Maps">
                    </iframe>
                </Box>
            </Card>
        </Box>
    );
}

export default Contact;
